import { type FC } from 'react';
import { AdUnit } from './AdUnit.tsx';

import { type OnAbsentAd } from '../hooks/useAbsentAdHandler.ts';
import { type OnSlotRenderEnded, type AdSizes } from '../types.ts';

import styles from '../styles/ads.scss';

type Props = {
    adId: string;
    elementId: string;
    width?: number;
    height?: number;
    lazyLoad?: boolean;
    sizes?: AdSizes;
    heightHold?: number;
    widthHold?: number;
    containerClassName?: string;
    onAbsentAd?: OnAbsentAd;
};

const onSlotRenderEnded: OnSlotRenderEnded = (event, ref, elementId) => {
    const iframe = ref.querySelector('iframe');
    if (event.slot.getSlotElementId() === elementId && iframe) {
        const adHeight = Array.isArray(event.size) ? event.size[1] : null;
        const innerDoc = iframe.contentDocument || iframe.contentWindow?.document;
        const body = innerDoc?.querySelector('body');
        const adImg = innerDoc?.querySelector('img');
        const imgLinkElement = adImg?.parentElement;
        const googleImgDiv = innerDoc?.querySelector('#google_image_div');
        googleImgDiv?.setAttribute('style', 'display: flex;');
        body?.setAttribute('style', 'display: flex; align-items: center; height: 100% !important;');
        innerDoc?.querySelector('html')?.setAttribute('style', 'height: 100%;');
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', adHeight ? `${adHeight}px` : '100%');
        adImg?.setAttribute('width', '100%');
        adImg?.setAttribute('height', '100%');
        adImg?.setAttribute('style', 'height: 100%; width: 100%; position: static;');
        imgLinkElement?.setAttribute('style', 'display: flex;');
    }
};

const ProductTileAd: FC<Props> = ({
    adId,
    elementId,
    width = 331,
    height = 419,
    lazyLoad = false,
    sizes,
    heightHold,
    widthHold,
    containerClassName,
    onAbsentAd,
}) => {
    return (
        <div
            className={containerClassName === undefined ? styles.tileContainer : containerClassName}
        >
            <div className={styles.tileInner} data-tn="product-tile-ad">
                <AdUnit
                    adId={adId}
                    elementId={elementId}
                    width={width}
                    height={height}
                    sizes={sizes}
                    heightHold={heightHold}
                    widthHold={widthHold}
                    className={styles.tilePlacement}
                    lazyLoad={lazyLoad}
                    onSlotRenderEnded={(event, ref) => onSlotRenderEnded(event, ref, elementId)}
                    onAbsentAd={onAbsentAd}
                    shouldCollapseOnNoFill
                />
            </div>
        </div>
    );
};

export { ProductTileAd };
